exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3LX90fVr{position:relative}._3LX90fVr._3n2JE4Ki{overflow:hidden}._3LX90fVr._3NlEnEih{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);background:#fff;max-height:67px}._3r5NOG98{white-space:nowrap;position:relative}.ykijmJtX{width:100%}.ykijmJtX._33CxX3wm{min-height:67px}", ""]);

// exports
exports.locals = {
	"switch": "_3LX90fVr",
	"moving": "_3n2JE4Ki",
	"bottom_panel": "_3NlEnEih",
	"switch__content": "_3r5NOG98",
	"panel": "ykijmJtX",
	"active": "_33CxX3wm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/slideView/style.less
// module id = 1300
// module chunks = 1